import React, { ReactNode } from 'react';

import {
  Header,
  HEADER_ID,
  PageContainer,
  PageHeading,
  Sidebar,
  SIDEBAR_ID,
} from '@/components/templates/PageLayout';
import { CmBox, CmFlex, CmScrollBox } from '@/components/uiParts';
import { useTargetsDomHeight } from '@/hooks/Dom';
import { SIDEBAR_WIDTH } from '@/styles';

interface Props {
  children: ReactNode;
  formComponsent?: ReactNode;
  title: string;
}

export const StoreManegementPageLayout: React.FC<Props> = ({
  children,
  formComponsent,
  title,
}) => {
  const { targetsHeight: headerHeight } = useTargetsDomHeight([HEADER_ID]);
  const contentHeight = `calc(100vh - ${headerHeight}px)`;
  return (
    <CmFlex position="relative">
      <CmBox
        position="fixed"
        top={0}
        zIndex={10}
        w={SIDEBAR_WIDTH}
        id={SIDEBAR_ID}
      >
        <Sidebar />
      </CmBox>
      <CmBox width="100%" ml={SIDEBAR_WIDTH}>
        <CmBox
          position="sticky"
          top={0}
          background="#fff"
          borderBottom="1px solid #718096"
          zIndex={5}
          px={7}
          py={2}
          id={HEADER_ID}
        >
          <CmFlex justifyContent="space-between" alignItems="center">
            {title !== '' && <PageHeading size="lg">{title}</PageHeading>}
            <Header />
          </CmFlex>
        </CmBox>
        <PageContainer>
          {/** @NOTE サイドバーをスクロールしたときに中央コンテンツまでスクロールをされるため対処。*/}
          <CmScrollBox height={contentHeight} pb={0}>
            {children}
          </CmScrollBox>
        </PageContainer>
      </CmBox>
      {formComponsent}
    </CmFlex>
  );
};
